import { useState, useEffect } from "react";

const C = {
  bg:"#FAF6EF", white:"#FFFFFF", sage:"#6B9E78", sageDark:"#4A7A57",
  sagePale:"#EBF4EC", sageLight:"#C8DFC8", gold:"#C8973C", goldPale:"#FDF3DC",
  navy:"#2C5F8A", navyDark:"#1A3A5C", navyPale:"#EEF4FA",
  ink:"#2A2A2A", mid:"#4A4A4A", soft:"#6A6A6A", border:"#E0D8CC", light:"#F0EAE0",
};
const font = "Palatino Linotype, Book Antiqua, Palatino, Georgia, serif";

function ExerciseDay({ day, isBundle, onUpgrade }) {
  const [expanded, setExpanded] = useState(null);

  return (
    <div style={{ background:C.white, borderRadius:16, border:`1px solid ${C.border}`, overflow:"hidden", marginBottom:16 }}>
      {/* Day header */}
      <div style={{ background:`linear-gradient(135deg, ${C.navy}, ${C.navyDark})`, padding:"16px 20px" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
          <div>
            <p style={{ fontSize:13, color:"rgba(255,255,255,0.7)", fontFamily:font, textTransform:"uppercase", letterSpacing:1, marginBottom:4 }}>Day {day.day}</p>
            <p style={{ fontSize:20, color:C.white, fontFamily:font, fontWeight:"bold", marginBottom:2 }}>{day.title}</p>
            <p style={{ fontSize:14, color:"rgba(255,255,255,0.8)", fontFamily:font }}>{day.focus}</p>
          </div>
          <div style={{ textAlign:"right" }}>
            <div style={{ background:"rgba(255,255,255,0.15)", borderRadius:12, padding:"8px 14px" }}>
              <p style={{ fontSize:22, color:C.white, fontFamily:font, fontWeight:"bold", lineHeight:1 }}>⏱</p>
              <p style={{ fontSize:13, color:"rgba(255,255,255,0.9)", fontFamily:font }}>{day.duration}</p>
            </div>
          </div>
        </div>
      </div>

      <div style={{ padding:"16px 20px" }}>
        {/* Warm up */}
        <div style={{ background:C.sagePale, borderRadius:12, padding:"12px 16px", marginBottom:12, border:`1px solid ${C.sageLight}` }}>
          <p style={{ fontSize:13, color:C.sageDark, fontFamily:font, fontWeight:"bold", textTransform:"uppercase", letterSpacing:1, marginBottom:4 }}>🌅 Warm Up · {day.warmup?.duration}</p>
          <p style={{ fontSize:15, color:C.sageDark, fontFamily:font, fontWeight:"bold", marginBottom:4 }}>{day.warmup?.name}</p>
          <p style={{ fontSize:14, color:C.mid, fontFamily:font, lineHeight:1.65 }}>{day.warmup?.instructions}</p>
        </div>

        {/* Exercises */}
        <p style={{ fontSize:13, color:C.soft, fontFamily:font, fontWeight:"bold", textTransform:"uppercase", letterSpacing:1, marginBottom:10 }}>Exercises</p>
        {(day.exercises || []).map((ex, i) => (
          <div key={i} style={{ border:`1px solid ${C.border}`, borderRadius:12, marginBottom:10, overflow:"hidden" }}>
            <button onClick={() => setExpanded(expanded===i ? null : i)}
              style={{ width:"100%", padding:"14px 16px", background:"none", border:"none", cursor:"pointer", display:"flex", alignItems:"center", gap:12, textAlign:"left" }}>
              <div style={{ width:32, height:32, borderRadius:8, background:C.navyPale, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                <span style={{ fontSize:14, color:C.navy, fontFamily:font, fontWeight:"bold" }}>{i+1}</span>
              </div>
              <div style={{ flex:1 }}>
                <p style={{ fontSize:16, color:C.ink, fontFamily:font, fontWeight:"bold", marginBottom:2 }}>{ex.name}</p>
                <p style={{ fontSize:13, color:C.soft, fontFamily:font }}>
                  {ex.sets && ex.reps ? `${ex.sets} × ${ex.reps}` : ex.duration || ""}
                </p>
              </div>
              <span style={{ color:C.sage, fontSize:18, transform:expanded===i?"rotate(180deg)":"none", transition:"transform 0.2s" }}>⌄</span>
            </button>
            {expanded===i && (
              <div style={{ padding:"0 16px 14px", borderTop:`1px solid ${C.light}` }}>
                <p style={{ fontSize:15, color:C.mid, fontFamily:font, lineHeight:1.75, marginBottom:8, paddingTop:12 }}>{ex.instructions}</p>
                {ex.modification && (
                  <div style={{ background:C.goldPale, borderRadius:8, padding:"8px 12px" }}>
                    <p style={{ fontSize:13, color:C.gold, fontFamily:font }}><strong>💡 Easier option:</strong> {ex.modification}</p>
                  </div>
                )}
              </div>
            )}
          </div>
        ))}

        {/* Cool down */}
        <div style={{ background:C.navyPale, borderRadius:12, padding:"12px 16px", marginBottom:12, border:`1px solid rgba(44,95,138,0.2)` }}>
          <p style={{ fontSize:13, color:C.navy, fontFamily:font, fontWeight:"bold", textTransform:"uppercase", letterSpacing:1, marginBottom:4 }}>🌙 Cool Down · {day.cooldown?.duration}</p>
          <p style={{ fontSize:15, color:C.navy, fontFamily:font, fontWeight:"bold", marginBottom:4 }}>{day.cooldown?.name}</p>
          <p style={{ fontSize:14, color:C.mid, fontFamily:font, lineHeight:1.65 }}>{day.cooldown?.instructions}</p>
        </div>

        {/* Encouragement */}
        {day.encouragement && (
          <div style={{ background:C.sagePale, borderRadius:12, padding:"12px 16px" }}>
            <p style={{ fontSize:15, color:C.sageDark, fontFamily:font, fontStyle:"italic", lineHeight:1.65 }}>💚 {day.encouragement}</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default function ExerciseScreen({ user, isBundle, onUpgrade }) {
  const [plan,     setPlan]     = useState(null);
  const [loading,  setLoading]  = useState(false);
  const [dayIdx,   setDayIdx]   = useState(0);
  const [error,    setError]    = useState(null);

  useEffect(() => {
    if (isBundle && !plan && !loading) {
      setLoading(true);
      fetch('/api/generate-exercise', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ profile: user || {} }),
      })
      .then(r => r.json())
      .then(data => {
        console.log('Exercise API response:', data);
        if (data.error) { console.error('Exercise API error:', data.error); setError(true); setLoading(false); return; }
        setPlan(Array.isArray(data) ? data : null);
        setLoading(false);
      })
      .catch(e => { console.error('Exercise fetch error:', e); setError(true); setLoading(false); });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Show upgrade prompt for trial/meal-only users
  if (!isBundle) return (
    <div style={{ flex:1, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:"40px 24px", textAlign:"center" }}>
      <div style={{ fontSize:64, marginBottom:20 }}>🏃</div>
      <h2 style={{ fontSize:26, color:C.ink, fontFamily:font, fontWeight:"normal", marginBottom:12 }}>Add an Exercise Plan</h2>
      <p style={{ fontSize:17, color:C.mid, fontFamily:font, lineHeight:1.7, maxWidth:320, marginBottom:28 }}>
        Get a personalised 3-day exercise routine built around your fitness level — updated monthly as you improve.
      </p>
      <div style={{ background:C.white, borderRadius:16, padding:"20px", border:`1px solid ${C.border}`, width:"100%", maxWidth:340, marginBottom:24, textAlign:"left" }}>
        {["Personalised to your fitness level","Home-based — no gym needed","Builds gradually each month","Complements your meal plan perfectly","Reviewed and updated monthly"].map((item,i) => (
          <div key={i} style={{ display:"flex", gap:10, padding:"8px 0", borderBottom:i<4?`1px solid ${C.light}`:"none" }}>
            <span style={{ color:C.sage }}>✓</span>
            <span style={{ fontSize:15, color:C.mid, fontFamily:font }}>{item}</span>
          </div>
        ))}
      </div>
      <div style={{ background:`linear-gradient(135deg, ${C.navy}, ${C.navyDark})`, borderRadius:16, padding:"20px", width:"100%", maxWidth:340, marginBottom:12 }}>
        <p style={{ fontSize:15, color:"rgba(255,255,255,0.8)", fontFamily:font, marginBottom:4 }}>Add to your current plan</p>
        <p style={{ fontSize:28, color:C.white, fontFamily:font, fontWeight:"bold", marginBottom:4 }}>Only $5 more/month</p>
        <p style={{ fontSize:14, color:"rgba(255,255,255,0.7)", fontFamily:font, marginBottom:16 }}>Upgrade from $19.99 to $24.99/month</p>
        <button onClick={() => onUpgrade && onUpgrade()}
          style={{ width:"100%", padding:"16px", background:`linear-gradient(135deg, ${C.gold}, #A8742A)`, color:C.white, border:"none", borderRadius:12, fontSize:17, fontFamily:font, fontWeight:"bold", cursor:"pointer" }}>
          Upgrade to Bundle →
        </button>
      </div>
      <p style={{ fontSize:13, color:C.soft, fontFamily:font }}>Cancel or change plan any time</p>
    </div>
  );

  if (loading) return (
    <div style={{ flex:1, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:"40px 28px", textAlign:"center" }}>
      <style>{`@keyframes pulse{0%,100%{transform:scale(1)}50%{transform:scale(1.08)}}`}</style>
      <div style={{ fontSize:64, marginBottom:20, animation:"pulse 1.8s ease infinite" }}>🏃</div>
      <p style={{ fontSize:20, color:C.ink, fontFamily:font, fontWeight:"normal", marginBottom:10 }}>Building your exercise plan...</p>
      <p style={{ fontSize:16, color:C.soft, fontFamily:font, fontStyle:"italic" }}>Personalised to your fitness level</p>
    </div>
  );

  if (error || !plan) return (
    <div style={{ flex:1, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:"40px 28px", textAlign:"center" }}>
      <div style={{ fontSize:48, marginBottom:16 }}>😕</div>
      <p style={{ fontSize:18, color:C.ink, fontFamily:font, marginBottom:20 }}>Couldn't load your exercise plan right now.</p>
      <button onClick={() => { setError(null); setPlan(null); setLoading(false); }}
        style={{ padding:"14px 32px", background:`linear-gradient(135deg, ${C.navy}, ${C.navyDark})`, color:C.white, border:"none", borderRadius:14, fontSize:16, fontFamily:font, fontWeight:"bold", cursor:"pointer" }}>
        Try Again
      </button>
    </div>
  );

  const today = plan[dayIdx];

  return (
    <div style={{ flex:1, overflowY:"auto", padding:"24px 20px 100px" }}>
      {/* Header */}
      <div style={{ marginBottom:20 }}>
        <h2 style={{ fontSize:26, color:C.ink, fontFamily:font, fontWeight:"normal", marginBottom:6 }}>Your Exercise Plan</h2>
        <p style={{ fontSize:15, color:C.soft, fontFamily:font }}>Personalised to your fitness level. Start gentle, build gradually.</p>
      </div>

      {/* Trial banner */}
      <div style={{ background:C.goldPale, border:`1px solid ${C.gold}44`, borderRadius:14, padding:"12px 16px", marginBottom:20, display:"flex", alignItems:"center", justifyContent:"space-between", gap:12 }}>
        <div>
          <p style={{ fontSize:14, color:C.gold, fontFamily:font, fontWeight:"bold", marginBottom:2 }}>✨ 3-Day Trial Plan</p>
          <p style={{ fontSize:14, color:C.mid, fontFamily:font }}>
            {isBundle ? "Full monthly plan active — refreshes each month" : "Upgrade to get a full monthly plan that updates as you progress"}
          </p>
        </div>
        {!isBundle && (
          <button onClick={() => onUpgrade && onUpgrade()}
            style={{ background:`linear-gradient(135deg, ${C.gold}, #A8742A)`, color:C.white, border:"none", borderRadius:20, padding:"8px 14px", fontSize:13, fontFamily:font, fontWeight:"bold", cursor:"pointer", whiteSpace:"nowrap" }}>
            Upgrade →
          </button>
        )}
      </div>

      {/* Day tabs */}
      <div style={{ display:"flex", gap:8, marginBottom:20 }}>
        {plan.map((d,i) => (
          <button key={i} onClick={() => setDayIdx(i)}
            style={{ flex:1, padding:"10px 6px", border:`2px solid ${dayIdx===i?C.navy:C.border}`, borderRadius:12, background:dayIdx===i?C.navyPale:C.white, cursor:"pointer" }}>
            <p style={{ fontSize:12, color:dayIdx===i?C.navy:C.soft, fontFamily:font, fontWeight:"bold", marginBottom:1 }}>Day {i+1}</p>
            <p style={{ fontSize:11, color:dayIdx===i?C.navy:C.soft, fontFamily:font }}>{d.duration}</p>
          </button>
        ))}
      </div>

      {/* Today's workout */}
      {today && <ExerciseDay day={today} isBundle={isBundle} onUpgrade={onUpgrade} />}
    </div>
  );
}
